import { Button, Stack, type StackProps, Typography, type TypographyProps } from '@mui/material';
import { useConnectModal } from '@rainbow-me/rainbowkit';
import React, { ReactNode, useCallback, useEffect, useRef } from 'react';
import { useAccount } from 'wagmi';

import { Actions } from 'src/global/constants/role.constant';

interface ActionGuardProps {
  action: Actions;
  message?: string;
  stackProps?: Omit<StackProps, 'children'>;
  typographyProps?: Omit<TypographyProps, 'children'>;
  children: ReactNode;
}

const ActionGuard: React.FC<ActionGuardProps> = ({ children }) => {
  const { address, isConnecting } = useAccount();
  const { openConnectModal } = useConnectModal();
  const hasOpenedRef = useRef(false);

  const maybeOpenConnect = useCallback(() => {
    if (!address && !isConnecting && !hasOpenedRef.current) {
      hasOpenedRef.current = true;
      openConnectModal?.();
    }
  }, [address, isConnecting, openConnectModal]);

  useEffect(() => {
    const t = setTimeout(maybeOpenConnect, 300);
    return () => clearTimeout(t);
  }, [maybeOpenConnect]);

  if (!address)
    return (
      <Stack alignItems={'center'} justifyContent={'center'} gap={2} paddingY={6}>
        <Typography variant='h6' textAlign={'center'}>
          Wallet required
        </Typography>
        <Typography variant='body2' color={'text.secondary'} textAlign={'center'}>
          Please connect your wallet to access this page.
        </Typography>
        <Button variant='contained' onClick={() => openConnectModal?.()}>
          Connect Wallet
        </Button>
      </Stack>
    );

  return <>{children}</>;
};

export default ActionGuard;
